import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'
import { Link } from 'react-router-dom'

import Button from '../../UniformComponents/Button'
import DataTable from '../DataTable'

import './mergeFields.scss'

@observer
class MergeFieldsSearch extends Component {
    tableColumns = [
        {
            name: 'Client ID',
            key: 'clientId',
            dataTransform: (clientId) => (
                clientId || 'All'
            ),
        },
        {
            name: 'Type',
            key: 'oid',
            dataTransform: (oid) => (
                oid === 7 ? 'Survey' : 'Product'
            ),
        },
        {
            name: 'Name',
            key: 'name',
        },
        {
            name: 'Merge Field Type',
            key: 'mergefieldType',
        },
        {
            name: 'Description',
            key: 'description',
        },
        {
            name: '',
            key: 'mergefieldId',
            dataTransform: (mergefieldId) => (
                <Link style={{ fontSize: '22px' }} className="fal fa-edit" to={`/intranet/mergefields/${mergefieldId}`} onClick={(e) => e.stopPropagation()} />),
        },
    ]

    constructor(props) {
        super(props)

        const { store } = props

        this.state = {
            mergeFields: [],
            ready: false,
        }

        store.breadcrumps = [
            {
                name: 'mergefields',
                url: '/intranet/mergefields',
                title: 'MergeFields',
            },
        ]
    }

    async componentDidMount() {
        const { store } = this.props
        const mergeFields = await store.http.get('/mergefield')
        this.setState({ mergeFields, ready: true })
    }

    renderDataTable = () => {
        const { history } = this.props
        const { mergeFields } = this.state
        const tableArgs = {
            data: mergeFields || [],
            columns: this.tableColumns,
            rowClick: (e, mergefieldId) => { history.push(`/intranet/mergefields/${mergefieldId}`) },
            rowId: 'mergefieldId',
            emptyMessage: 'There are no merge fields',
        }

        if (tableArgs.data.length > 0) {
            return (
                <DataTable
                    store={{ filteredList: tableArgs.data }}
                    dataSet={tableArgs.data}
                    columns={tableArgs.columns}
                    rowClick={tableArgs.rowClick}
                    rowId={tableArgs.rowId}
                    inMemory
                />
            )
        }
        return <div>{tableArgs.emptyMessage}</div>
    }

    goToNew = () => {
        const { history } = this.props
        history.push('/intranet/mergefields/0')
    }

    render() {
        const { ready } = this.state
        return (
            <div id="mergeFieldSearch" className="mergeFieldSearch">
                <div>
                    {ready
                    && (
                        <div className="panel">
                            <Button
                                type="button"
                                cssClass="regular primary"
                                onClick={this.goToNew}
                            >
                                Create New Merge Field
                            </Button>
                            {this.renderDataTable()}
                        </div>
                    )}
                </div>
            </div>

        )
    }
}

export default MergeFieldsSearch
